import { useEffect, type ReactNode } from "react";
import AuthBrandPanel from "../presentation/components/auth-brand-panel";
import { preloadAuthAssets } from "../preload-assets";

type AuthSplitLayoutProps = {
  children: ReactNode;
};

export function AuthSplitLayout({ children }: AuthSplitLayoutProps) {
  useEffect(() => {
    preloadAuthAssets();
  }, []);

  return (
    <main className="flex h-screen w-full overflow-hidden bg-bgWhite max-lg:h-auto max-lg:min-h-screen max-lg:overflow-visible">
      <div aria-hidden className="hidden h-full w-1/2 shrink-0 lg:block">
        <AuthBrandPanel />
      </div>
      <section className="flex min-w-0 flex-1 justify-center overflow-y-auto px-4 pb-12 pt-6 max-lg:overflow-visible sm:px-12 sm:pb-32 sm:pt-16">
        <div className="flex w-full max-w-[528px] flex-col items-center gap-6 self-start">
          {children}
        </div>
      </section>
    </main>
  );
}

export default AuthSplitLayout;
